import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useFollowers(userId, filters = {}) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchFollowers() {
      setLoading(true);
      const { response, data } = await API.fetchFollowers(userId, filtersToQueryParams(filters));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      }
    }

    if (userId) {
      fetchFollowers();
    }
  }, [userId, Object.values(filters).join("__")]);

  return {
    loading,
    results: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
